import { Component, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NavController, MenuController, Platform } from '@ionic/angular';
import { User } from './login.interface';
import { Utils } from '../../service/utils';
import { LoginProvider } from './login.service';
import { CacheService } from 'ionic-cache';

import { forkJoin } from 'rxjs';
import { first } from 'rxjs/operators';

import _ from 'lodash';
import * as $ from 'jquery';

import { ImageConstants } from '../../service/image-constants';

@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
  providers: [LoginProvider],
  styleUrls: ['login.scss']
})
export class LoginPage {
  login: FormGroup;
  isApp: boolean;
  isSubmitted: boolean;
  isLoading: boolean;
  errorMessage: string;
  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.onResize();
  }
  constructor(
    public navCtrl: NavController,
    public actRoute: ActivatedRoute,
    public menu: MenuController,
    private formBuilder: FormBuilder,
    public utils: Utils,
    public Login: LoginProvider,
    public dialog: MatDialog,
    private cache: CacheService,
    public imageConstants: ImageConstants,
    private platform: Platform
  ) {
    this.login = this.formBuilder.group({
      userName: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required])
    });

    this.errorMessage = '';
    this.menu.enable(false);
    this.isSubmitted = false;
    this.isLoading = false;
    this.onResize(); // determine if its the app using ionic
  }

  resetPass = () => {
    this.navCtrl.navigateForward('/reset-password');
  };

  goToForgotten = () => {
    this.navCtrl.navigateForward('/forgotten-password');
    if (this.isApp) {
      this.utils.apptentiveEngage('Forgot Password');
    }
  };

  goToRegister = () => {
    this.navCtrl.navigateForward('/register');
  };

  onResize = () => {
    this.isApp = this.utils.isApp();
  };

  onSubmit = ({ value, valid }: { value: User; valid: boolean }) => {
    this.errorMessage = '';
    this.isLoading = true;
    localStorage.clear();
    this.cache.clearAll();
    this.Login.login(value).subscribe(
      response => {
        //response has access token
        let loginResponse = response;
        let isEdge = navigator.userAgent.indexOf('Edge') > -1;

        // login is good, lets check if there is a servic-worker, if not then lets create one
        if ('serviceWorker' in navigator && !this.platform.is('ios') && !isEdge) {
          // cannot be done cause as of iOS 11, there is no service worker yet
          navigator.serviceWorker.getRegistrations().then(
            registrations => {
              console.log(registrations.length);
              if (registrations.length <= 0) {
                navigator.serviceWorker
                  .register('service-worker.js', { scope: '/' })
                  .then(() => console.log('service worker installed'))
                  .catch(err => console.error('Error', err));
              }
            },
            err => {
              console.error('Error with service worker:', err);
            }
          );
        }

        this.cache.setDefaultTTL(loginResponse.expires_in);
        this.cache.saveItem('loginInfo', loginResponse);

        forkJoin([
          this.Login.getMaterials(loginResponse),
          this.Login.getMachine(loginResponse),
          this.Login.getPdfSupportInfo(loginResponse),
          this.Login.getEndmillSearchStrings(loginResponse),
          this.Login.getLatestToolVersion(loginResponse)
        ]).subscribe(res => {
          if (this.utils.isApp()) {
            //lets get the dimensions and reuse those for mobile

            // lets do some math to predetermine the heights
            // need to chunk out 3 sections
            // 1. header menu = 10%
            // 2. the content = 60%
            // 3. the tab menu = 10%
            // 4. the group menu = 20%

            let windowsDimensions = {
              w: window.innerWidth,
              h: window.innerHeight,
              headerHeight: window.innerHeight * 0.1,
              contentHeight: window.innerHeight * 0.7,
              tabMenuHeight: window.innerHeight * 0.05,
              groupMenuHeight: window.innerHeight * 0.15
            };
            this.cache.saveItem('windowsDimensions', windowsDimensions);
            $('body').css({
              width: window.innerWidth + 'px',
              height: window.innerHeight + 'px'
            });
            this.utils.apptentiveEngage('Login');
          }

          this.cache.saveItem('materials', res[0]);
          this.cache.saveItem('machine', res[1]);
          this.cache.saveItem('pdfSupportInfo', res[2]);
          this.cache.saveItem('endmillSearchStrings', res[3]);
          this.cache.saveItem('toolVersion', res[4]);

          this.cache.saveItem('endmills', {});
          this.cache.saveItem('endmillsCached', false);
          this.cache.saveItem('operations', {});
          this.cache.saveItem('operationsCached', false);
          this.cache.saveItem('allParamsAndRecsCached', false);

          this.isSubmitted = true;
          this.isLoading = false;

          this.actRoute.queryParams.pipe(first()).subscribe(params => {
            const brand: string = params['brand'] || 'null';
            const sku: string = params['sku'] || 'null';

            this.navCtrl.navigateForward(`/tool/${brand}/${sku}`);
          });
        });
      },
      error => {
        this.isLoading = false;
        this.errorMessage = error;
        this.utils.openDialog(error, 'error');
      }
    );
  };

  ngOnInit = () => {
    console.log('ionViewDidLoad ShowPage');
  };
}
